import { useQuery } from '@tanstack/react-query';
import { FavoriteRepositoryImpl } from '../../data/repository/favorite_repository_impl';
import { useMemo } from 'react';
import useWindowSize from '../../../../core/utils/use_windows_size';
import { ResourceInterface } from '../interface/resource_interface';

const BASE_PADDING_PERCENT = 0.3 * 2;
const LG_PADDING_PERCENT = 0.1 * 2;
const GAP_SIZE = 12;
const RESOURCE_ELEMENT_WIDTH = 130;

export const useGetFavoritesByUserIdAndThemeId = (userId?: string, themeId?: string, limit: boolean = true) => {
  const repository = new FavoriteRepositoryImpl();
  const { width: screenWidth } = useWindowSize();

  const queryResult = useQuery({
    queryFn: () => repository.getFavoritesByUserIdAndThemeId(userId!, themeId!),
    queryKey: ['favoritesByUserIdAndThemeId', userId, themeId],
    enabled: !!userId && !!themeId,
  });

  const calculateRequiredItems = useMemo(() => {
    const isLarge = screenWidth >= 1024;
    const horizontalPadding = isLarge 
      ? BASE_PADDING_PERCENT * screenWidth 
      : LG_PADDING_PERCENT * screenWidth;
      
    const availableWidth = screenWidth - horizontalPadding;
      
    const itemsCount = Math.floor((availableWidth + GAP_SIZE) / (RESOURCE_ELEMENT_WIDTH + GAP_SIZE));
      
    return Math.max(itemsCount + 3, 10);
  }, [screenWidth]);

  const filteredFavorites: ResourceInterface[] = useMemo(() => {
    return queryResult.data?.map(fav => {
      return { ...fav._resourceId, viewed: fav.viewed };
    }) || [];
  }, [queryResult.data]);
  const favorites = useMemo(() => {
    return limit ? filteredFavorites.slice(0, calculateRequiredItems) : filteredFavorites || [];
  }, [filteredFavorites, calculateRequiredItems, limit]);
  const hasMoreFavorites = useMemo(() => {
    return filteredFavorites.length > calculateRequiredItems;
  }, [filteredFavorites, calculateRequiredItems]);

  return {
    ...queryResult,
    favorites,
    hasMoreFavorites,
  };

};
